import { C } from "../theme";
import type { PriceLevel } from "../types";

/** Tibber band edges as a fraction of the trailing mean (mirrors the worker). */
const BANDS = { CHEAP: 0.6, NORMAL: 0.9, EXPENSIVE: 1.15, VERY_EXPENSIVE: 1.4 } as const;

/** Classify a kr/kWh price against the trailing mean — same logic as the brain. */
export function priceLevelOf(price: number, mean: number): PriceLevel {
  if (!(mean > 0.02)) return price <= 0.02 ? "VERY_CHEAP" : "UNKNOWN";
  if (price <= 0) return "VERY_CHEAP";
  const r = price / mean;
  if (r <= BANDS.CHEAP) return "VERY_CHEAP";
  if (r <= BANDS.NORMAL) return "CHEAP";
  if (r < BANDS.EXPENSIVE) return "NORMAL";
  if (r < BANDS.VERY_EXPENSIVE) return "EXPENSIVE";
  return "VERY_EXPENSIVE";
}

/** Sage→coral ramp: cheap is good (green), expensive is bad (amber/coral). */
export const priceLevelColor = (l: PriceLevel): string =>
  ({
    VERY_CHEAP: C.sageDeep,
    CHEAP: C.sage,
    NORMAL: C.sea,
    EXPENSIVE: C.beacon,
    VERY_EXPENSIVE: C.coral,
    UNKNOWN: C.textLow,
  })[l] ?? C.textMid;

export const priceLevelLabel = (l: PriceLevel): string =>
  ({
    VERY_CHEAP: "Very cheap",
    CHEAP: "Cheap",
    NORMAL: "Normal",
    EXPENSIVE: "Expensive",
    VERY_EXPENSIVE: "Very expensive",
    UNKNOWN: "Unknown",
  })[l] ?? "—";
